<template>
  <div>
    <div class="row grid-12 justify-space">
      <div
        class="title left column justify-center grid-3-g grid-6-m grid-12-s"
        :class="obrigatorias && 'active'"
        @click="obrigatorias = true"
      >
        <div class="grid-12">
          Pendências
          <strong>Obrigatórias</strong>
        </div>
      </div>
      <div
        class="
          title
          right
          column
          justify-center
          grid-3-g grid-6-m grid-12-s
          align-end
          text-right
        "
        :class="!obrigatorias && 'active'"
        @click="obrigatorias = false"
      >
        <div class="grid-12">
          Pendências
          <strong>Opcionais</strong>
        </div>
      </div>
    </div>

    <div class="content">
      <div v-if="obrigatorias" class="row wrap">
        <div class="grid-12 subtitle">
          Para começar a prestar atendimentos complete as pendências.
        </div>
        <CardPendency
          v-for="p of user.pendency.obrigatorias"
          :pendency="{ ...p, callback: loadPendencies }"
          :key="'obrigatoria' + p.id"
        />
        <div
          v-if="
            user.pendency.obrigatorias.filter((r) => r.status == 'paga').length ==
            user.pendency.obrigatorias.length
          "
          class="column justify-center align-center empty grid-12"
        >
          <img src="../../assets/img/congratulations.png" width="60" />
          <br />
          <div class="column text-center justify-center">
            <h3>Parabéns!</h3>
            Você resolveu todas as pendências obrigatórias!
          </div>
        </div>
      </div>
      <div v-else class="row wrap">
        <div class="grid-12 subtitle">
          Essas pendências te ajudam a garantir mais pontos na hora de se
          candidatar aos <b>Jobs</b>.
        </div>
        <CardPendency
          v-for="p of user.pendency.nao_obrigatorias"
          :pendency="{ ...p, callback: loadPendencies }"
          :key="'nobrigatoria' + p.id"
        />
        <div
          v-if="
            user.pendency.nao_obrigatorias.filter((r) => r.status == 'paga')
              .length == user.pendency.nao_obrigatorias.length
          "
          class="column justify-center align-center empty grid-12"
        >
          <img src="../../assets/img/congratulations.png" width="60" />
          <br />
          <div class="column text-center justify-center">
            <h3>Parabéns!</h3>
            Você resolveu todas as pendências não obrigatórias!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import CardPendency from "@/components/CardPendency.vue";

export default {
  name: "Pendency",
  components: { CardPendency },
  data() {
    return {
      obrigatorias: true,
    };
  },
  methods: {
    ...mapMutations("user", ["SET_USER"]),
    ...mapActions("user", ["GET_PENDENCIES"]),
    loadPendencies() {
      this.GET_PENDENCIES();
    },
  },
  beforeMount() {
    this.loadPendencies();
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.content {
  background: $white-10;
  padding: 20px;
  border-left: 1px solid #ccc;
  border-right: 2px solid #ccc;
  border-bottom: 4px solid #ccc;
  border-radius: 0px 0px 23px 23px;
  .empty {
    height: 50vh;
  }
  .subtitle {
    text-align: center;
    padding: 40px;
    font-size: 17px;
  }
}
.title {
  background: $white-4;
  padding: 33px;
  cursor: pointer;
  font-size: 28px;
  font-weight: 400;
  @media (max-width: $small) {
    font-size: 19px;
    padding: 26px 20px;
    margin-top: 30px;
  }
  @media (max-width: $medium) {
    font-size: 21px;
  }
  &.left {
    border-radius: 30px 70px 0 0;
    &.active {
      border: none;
      border-left: 1px solid #ccc;
    }
  }
  strong {
    color: $red;
  }
  label {
    font-size: 14px;
    margin-top: 6px;
  }
  &:hover {
    strong {
      text-decoration: underline;
    }
  }
  &.right {
    border-radius: 70px 30px 0 0;
    /* border-right: 2px solid #ccc; */
    strong {
      color: $supporter-1;
    }
    &.active {
      border: none;
      border-right: 2px solid #ccc;
      /*   border-radius: 30px 90px 0 0; */
    }
  }
  &.active {
    background: $white-10;
  }
}
</style>
